export const BundleProductPricesTypes = {
  CREDIT_PRICE: 'CREDIT_PRICE',
  CREDIT_PRICE24: 'CREDIT_PRICE24',
  FIRST_BILL: 'FIRST_BILL',
  FULL_PRICE: 'FULL_PRICE',
};
